(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds-mine.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/odds-slider/matchen-odds-mine.js');

(function(Backbone, _, svs) {
  svs.matchen.views.MatchenOddsMine = Marionette.CollectionView.extend({
    template: function() {
      return '<div class="matchen-my-odds-list"></div>';
    },
    collectionEvents: {
      sortDone: 'render'
    },
    className: 'matchen-my-odds-container',
    childView: svs.matchen.views.MatchenOddsItem,
    childViewContainer: '.matchen-my-odds-list',
    modelEvents: {
      change: 'onCouponValidChange',
      'change:numberOfRows': 'onNumberOfRowsChange'
    },
    emptyView: svs.matchen.views.MatchenOddsEmpty,
    emptyViewOptions: function() {
      return {
        model: new Backbone.Model({
          exceedsPrintableRowsLimit: this.model.get('isValid'),
          exceedsMaxRows:
            this.model.get('numberOfRows') >
            svs.matchen.data.matchenconfig.gameLimits.maxRows,
          isXpertenActive: this.model.get('xperten').isActive()
        })
      };
    },

    onNumberOfRowsChange: function() {
      this.render();
    },

    onCouponValidChange: function() {
      if (this.model.get('isValid')) {
        this.collection.fetch({ parse: true, reset: true });
        this.render();
      } else {
        this.collection.reset([]);
      }
    }
  });
})(Backbone, _, svs);


 })(window);